import { render } from "./logoInfiniteScrollTemplate.vue?vue&type=template&id=0c228a2a&scoped=true"
import script from "./logoInfiniteScrollTemplate.vue?vue&type=script&lang=js"
export * from "./logoInfiniteScrollTemplate.vue?vue&type=script&lang=js"

import "./logoInfiniteScrollTemplate.vue?vue&type=style&index=0&id=0c228a2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c228a2a"]])

export default __exports__